import PaginationData from "@/models/general/PaginationData";
import EmployeeFolder from "./EmployeeFolder";
import EmployeeFoldersFilter from "./EmployeeFoldersFilter";

export default class EmployeeFolders {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.pagination = new PaginationData();
    this.employeeFoldersData = [];
    this.employeeFolder = new EmployeeFolder();
    this.filterData = new EmployeeFoldersFilter();
  }
  fillData(data) {
    this.status = data.status;
    this.msg = data.msg;
    this.pagination.fillData(data.employeeFoldersPagination);
    this.employeeFoldersData =
      data.employeeFoldersPagination.employeeFoldersData;
  }
}
